import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/console/member/statistic";

export const member = {
    // ...example,
    statistic: {
        get(){
            return axios.get(`${url}`).then(result => result.data);
        },
    }
}
